/**
 * Checks if given property is a `string` type
 * @param prop to be checked
 * @returns true if input is a string, false otherwise
 *
 * @author louiiuol
 */
export const isString = (prop: unknown) => typeof prop === 'string';
